import { RichText } from "@atlassiansox/bxp-content-framework";

import { AnalyticsAttributesProvider } from "../../components";
import { UiSocialProofModel } from "../../models";
import { renderViewModel } from "../../render-view-model";

import {
    SocialProof,
    QuoteFigure,
    ProductFact,
    ProductFactLink,
    Quote,
    QuoteCaption,
    QuoteImageLink,
    ShadowWrapper
} from "./UiSocialProof.styles";

export type UiSocialProofProps = {
    readonly model: UiSocialProofModel;
};

const UiSocialProof = ({
    model: {
        id,
        type,
        content: {
            background,
            customerDetails,
            customerLogoImage,
            customerName,
            customerQuote,
            customerStoryLink,
            entryTitle,
            productFact,
            productFactLink
        }
    }
}: UiSocialProofProps) => {
    return (
        <AnalyticsAttributesProvider
            value={{
                eventContainer: type,
                parentLabel: entryTitle
            }}
        >
            <ShadowWrapper>
                <SocialProof data-uuid={id}>
                    <QuoteFigure background={background}>
                        <Quote>
                            <RichText document={customerQuote} />
                        </Quote>
                        <QuoteCaption>
                            <p>{customerName}</p>
                            <p>{customerDetails}</p>
                            <QuoteImageLink>
                                {customerLogoImage &&
                                    renderViewModel(customerLogoImage)}
                                {customerStoryLink &&
                                    renderViewModel(customerStoryLink)}
                            </QuoteImageLink>
                        </QuoteCaption>
                    </QuoteFigure>
                    <ProductFact background={background}>
                        <h3>{productFact}</h3>
                        {productFactLink && (
                            <ProductFactLink>
                                {renderViewModel(productFactLink)}
                            </ProductFactLink>
                        )}
                    </ProductFact>
                </SocialProof>
            </ShadowWrapper>
        </AnalyticsAttributesProvider>
    );
};

export default UiSocialProof;
